"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISubscriptionOrigin = exports.ISubscriptionFrozen = exports.ISubscriptionInactive = void 0;
var ISubscriptionInactive;
(function (ISubscriptionInactive) {
    ISubscriptionInactive[ISubscriptionInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    ISubscriptionInactive[ISubscriptionInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(ISubscriptionInactive = exports.ISubscriptionInactive || (exports.ISubscriptionInactive = {}));
var ISubscriptionFrozen;
(function (ISubscriptionFrozen) {
    ISubscriptionFrozen[ISubscriptionFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    ISubscriptionFrozen[ISubscriptionFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(ISubscriptionFrozen = exports.ISubscriptionFrozen || (exports.ISubscriptionFrozen = {}));
var ISubscriptionOrigin;
(function (ISubscriptionOrigin) {
    ISubscriptionOrigin[ISubscriptionOrigin["CUSTOMER_WILL_BE_SUBSCRIBING_THROUGH_ECOMMERCE_2"] = 2] = "CUSTOMER_WILL_BE_SUBSCRIBING_THROUGH_ECOMMERCE_2";
    ISubscriptionOrigin[ISubscriptionOrigin["ORIGINATED_IN_A_PAYFRAME_8"] = 8] = "ORIGINATED_IN_A_PAYFRAME_8";
    ISubscriptionOrigin[ISubscriptionOrigin["ORIGINATED_WITH_APPLE_PAY_4"] = 4] = "ORIGINATED_WITH_APPLE_PAY_4";
    ISubscriptionOrigin[ISubscriptionOrigin["CUSTOMER_WILL_BE_SUBSCRIBING_BY_MAIL_ORDERTELEPHONE_3"] = 3] = "CUSTOMER_WILL_BE_SUBSCRIBING_BY_MAIL_ORDERTELEPHONE_3";
    ISubscriptionOrigin[ISubscriptionOrigin["ORIGINATED_AS_A_SUCCESSFUL_D_SECURE_TRANSACTION_5"] = 5] = "ORIGINATED_AS_A_SUCCESSFUL_D_SECURE_TRANSACTION_5";
    ISubscriptionOrigin[ISubscriptionOrigin["ORIGINATED_AS_AN_ATTEMPTED_D_SECURE_TRANSACTION_6"] = 6] = "ORIGINATED_AS_AN_ATTEMPTED_D_SECURE_TRANSACTION_6";
})(ISubscriptionOrigin = exports.ISubscriptionOrigin || (exports.ISubscriptionOrigin = {}));
